
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class ProductService extends BaseApi {


    constructor(){
        super();
    }


    async list(business, filter)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/products${filter}`)
        .catch(this.handleErrorResponse);
    }


    async selectData(business)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/products/catalog`)
        .catch(this.handleErrorResponse);
    }


    async get(business, id)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/products/${id}`)
        .catch(this.handleErrorResponse);
    }

    async store(business, data)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/products`, data)
        .catch(this.handleErrorResponse);
    }


    async update(business, id, data)
    {
        return this.http.put(`${this.baseUrl}/business/${business}/products/${id}`, data)
        .catch(this.handleErrorResponse);
    }


    async delete(business, id)
    {
        return this.http.delete(`${this.baseUrl}/business/${business}/products/${id}`)
        .catch(this.handleErrorResponse);
    }



}